import { Box } from "@mui/material";
import SettingsComponent from "../../components/account/settings";
function SettingsPage() {
  return <Box>{<SettingsComponent />}</Box>;
}

export default SettingsPage;
